(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['react', 'react-dom', 'spin.js', 'prop-types', 'create-react-class'], factory);
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(require('react'), require('react-dom'), require('spin.js'), require('prop-types'), require('create-react-class'));
  } else {
    root.Loader = factory(root.React, root.ReactDOM, root.Spinner, root.PropTypes, root.createReactClass);
  }
})(this, function (React, ReactDOM, Spinner, PropTypes, createReactClass) {
  var hasCreateRef = !!React.createRef;
  var Loader = createReactClass({
    propTypes: {
      className: PropTypes.string,
      color: PropTypes.string,
      component: PropTypes.any,
      corners: PropTypes.number,
      direction: PropTypes.oneOf([1, -1]),
      fps: PropTypes.number,
      hwaccell: PropTypes.bool,
      left: PropTypes.string,
      length: PropTypes.number,
      lines: PropTypes.number,
      loaded: PropTypes.bool,
      loadedClassName: PropTypes.string,
      opacity: PropTypes.number,
      options: PropTypes.object,
      parentClassName: PropTypes.string,
      position: PropTypes.string,
      radius: PropTypes.number,
      rotate: PropTypes.number,
      scale: PropTypes.number,
      shadow: PropTypes.bool,
      speed: PropTypes.number,
      top: PropTypes.string,
      trail: PropTypes.number,
      width: PropTypes.number,
      zIndex: PropTypes.number
    },
    getDefaultProps: function getDefaultProps() {
      return {
        component: 'div',
        loadedClassName: 'loadedContent',
        parentClassName: 'loader'
      };
    },
    getInitialState: function getInitialState() {
      this.ref = hasCreateRef ? React.createRef() : 'loader';
      return {
        loaded: false,
        options: {}
      };
    },
    componentDidMount: function componentDidMount() {
      this.updateState(this.props);
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.updateState(nextProps);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.setState({
        loaded: false
      });
    },
    updateState: function updateState(props) {
      props || (props = {});
      var loaded = this.state.loaded;
      var options = this.state.options;

      // update loaded state, if supplied
      if ('loaded' in props) {
        loaded = !!props.loaded;
      }

      // update spinner options, if supplied
      var allowedOptions = Object.keys(this.constructor.propTypes);
      allowedOptions.splice(allowedOptions.indexOf('loaded'), 1);
      allowedOptions.splice(allowedOptions.indexOf('options'), 1);

      // allows passing options as either props or as an option object
      var propsOrObjectOptions = 'options' in props ? props.options : props;
      allowedOptions.forEach(function (key) {
        if (key in propsOrObjectOptions) {
          options[key] = propsOrObjectOptions[key];
        }
      });
      this.setState({
        loaded: loaded,
        options: options
      }, this.spin);
    },
    spin: function spin() {
      var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
      if (canUseDOM && !this.state.loaded) {
        var spinner = new Spinner(this.state.options);
        var target;
        if (hasCreateRef) {
          target = this.ref.current;
        } else {
          target = ReactDOM.findDOMNode(this.refs.loader);
        }

        // clear out any other spinners from previous renders
        target.innerHTML = '';
        spinner.spin(target);
      }
    },
    render: function render() {
      var props, children;
      if (this.state.loaded) {
        props = {
          key: 'content',
          className: this.props.loadedClassName
        };
        children = this.props.children;
      } else {
        props = {
          key: 'loader',
          ref: this.ref,
          className: this.props.parentClassName
        };
      }
      return React.createElement(this.props.component, props, children);
    }
  });
  return Loader;
});